const storage = {
    not_configured: 'Nie skonfigurowano dostawcy magazynu.',
    missing_parameter: 'Brak parametru {{parameter}} dla dostawcy magazynu.',
    upload_error: 'Nie udało się przesłać pliku do dostawcy magazynu.',
    download_error: 'Failed to download file from the storage provider.',
};
export default Object.freeze(storage);
